import axios from "axios";
import { APIHost } from "./helpers";

export const baseURL = () => APIHost() + "/general/admin/luckyDraw";

export const loadLuckyDrawCount = data => axios.post(`${baseURL()}/count`, data);
export const loadLuckyDrawList = data => axios.post(`${baseURL()}/load`, data);
export const loadLuckyDrawDetail = (id, data) => axios.post(`${baseURL()}/load/${id}`, data);
export const createLuckyDraw = data => axios.post(`${baseURL()}/create`, data);
export const updateLuckyDraw = (id, data) => axios.post(`${baseURL()}/update/${id}`, data);
export const updateLuckyDrawActive = (id, data) => axios.post(`${baseURL()}/updateActive/${id}`, data);
export const removeLuckyDraw = (id, data) => axios.post(`${baseURL()}/remove/${id}`, data);
export const createLuckyDrawPrize = (id, data) => axios.post(`${baseURL()}/prize/create/${id}`, data);
export const updateLuckyDrawPrize = (id, data) => axios.post(`${baseURL()}/prize/update/${id}`, data);
export const removeLuckyDrawPrize = (id, data) => axios.post(`${baseURL()}/prize/remove/${id}`, data);
export const loadLuckyDrawPrize = (id, data) => axios.post(`${baseURL()}/prize/load/${id}`, data);
export const loadLuckyDrawParticipant = (id, data) => axios.post(`${baseURL()}/participant/load/${id}`, data);
export const updateLuckyDrawParticipantEligible = (id, data) => axios.post(`${baseURL()}/participant/eligible/update/${id}`, data);
export const loadLuckyDrawResult = (id, data) => axios.post(`${baseURL()}/result/load/${id}`, data);